// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import ListItemForm from './list-item-form';
import MassProcessInvoiceItem from './mass-process-invoice-item';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../../shared/components/warranty-loading-indicator';

function handleCancelClick() {

    this.actions.cancelInvoiceSubmission();

}

function handleInvoiceNumberChange(dealerInvoiceNumber) {

    this.actions.updateMassProcess('dealerInvoiceNumber', dealerInvoiceNumber);

}

function handleInvoiceSubmission() {

    this.actions.updateDealerInvoices(this.invoice);

}

const MassProcessInvoice = props =>
    <div className='mass-process-invoice-view'>
        <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
        <MassProcessInvoiceItem
            dealer={props.invoice.dealer}
            invoice={props.invoice.massProcess}
            isInvoiceNumberVisible={false}
            user={props.user}
        />
        <ListItemForm
            invoice={props.invoice}
            onCancelClick={props::handleCancelClick}
            onInvoiceNumberChange={props::handleInvoiceNumberChange}
            onInvoiceSubmission={props::handleInvoiceSubmission}
        />
    </div>;

MassProcessInvoice.displayName = 'MassProcessInvoice';
MassProcessInvoice.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    invoice: PropTypes.instanceOf(Invoice).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default MassProcessInvoice;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/mass-process-invoice/mass-process-invoice.js